import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Download from "@/views/Download.vue";
import Documentation from "@/views/Documentation.vue";
import Tutorials from "@/views/Tutorials.vue";
import Contact from "@/views/Contact.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/download",
    name: "Download",
    component: Download
  },
  {
    path: "/documentation",
    name: "Documentation",
    component: Documentation
  },
  {
    path: "/news",
    redirect: { path: "/", query: { section: "novedades" } }
  },
  {
    path: "/tutorials",
    name: "Tutorials",
    component: Tutorials
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    if (to.path === "/" && to.query.section === "novedades") {
      return { selector: "#novedades" };
    }
    return { x: 0, y: 0 };
  }
});

export default router;
